import { render, staticRenderFns } from "./AssociarBanco.vue?vue&type=template&id=48d66ab6&"
import script from "./AssociarBanco.vue?vue&type=script&lang=js&"
export * from "./AssociarBanco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports